import { Summary } from './Summary.js';
import { ComOrderMapper } from '../../../models/Com/ComOrderMapper.js';

class ComOrderRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.summary = new Summary(apiClient);
  }
  post(shipment, payment, voucher) {
    var _priority$available;
    let invoiceRequested = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let customsInvoiceId = arguments.length > 4 ? arguments[4] : undefined;
    let carriersTermsAndConditions = arguments.length > 5 ? arguments[5] : undefined;
    const from = shipment.from;
    const to = shipment.to;
    const content = shipment.content;
    const collection = shipment.collection;
    const dropoffPointId = shipment.dropoffPointId;
    const service = shipment.service;
    const parcels = shipment.parcels;
    const upsales = shipment.upsales;
    const insurance = upsales.insurance;
    const cod = upsales.cashOnDelivery;
    const priority = upsales.priority;
    const shipments = [{
      ...(cod && {
        cash_on_delivery: cod.getCreatePayload()
      }),
      ...(collection && collection.getCreatePayload()),
      ...(dropoffPointId && {
        dropoff_point_id: dropoffPointId
      }),
      ...service.getCreatePayload(),
      content: content.description,
      content_second_hand: false,
      contentvalue: content.value,
      from: from.getCreatePayload(),
      insurance: insurance.getCreatePayload(),
      packages: parcels.map(p => p.getCreatePayload()),
      price: {},
      to: to.getCreatePayload(),
      voucher_name: voucher === null || voucher === void 0 ? void 0 : voucher.name,
      ...(customsInvoiceId && {
        customs: {
          customs_invoice_id: customsInvoiceId
        }
      }),
      priority: (_priority$available = priority === null || priority === void 0 ? void 0 : priority.available) !== null && _priority$available !== void 0 ? _priority$available : false
    }];
    return this.apiClient.post('com/orders', ComOrderMapper.getCreatePayload({
      payment,
      shipments,
      invoiceRequested,
      carriersTermsAndConditions
    })).then(res => ComOrderMapper.createModelFromResponse(res.data));
  }
}

export { ComOrderRepository };
//# sourceMappingURL=ComOrderRepository.js.map
